
<mat-card>

  <h2 class="titleDialog">Erros</h2>

<div *ngFor="let item of data">
  <mat-card class="customCard">{{item}}</mat-card>
</div>

<div class="row d-flex justify-content-center">


  <div mat-dialog-actions>
    <button mat-button class="btn btn-secondary" (click)="onNoClick()">OK</button>
  </div>


</div>
</mat-card>
